<template>
  <div class="font-code">
    <div class="flex justify-center">
      <p class="mx-2 text-default hover:text-link">
        <a href="https://www.linkedin.com/in/klaassenconnor/" target="_blank" rel="noopener noreferrer">
          <Icon class="mr-2" :icon="['fab', 'linkedin']"/>
          <u>Connor Klaassen</u>
        </a>
      </p>
      <p class="text-default hover:text-link">
        <a href="mailto:cklaasse@purdue.edu">
          <u>cklaasse@purdue.edu</u>
          <Icon class="ml-2" :icon="['fas', 'envelope-square']"/>
        </a>
      </p>
    </div>
    <div class="flex justify-center">
      <p class="text-default hover:text-link"><a href="https://gitlab.com/cklaassen" target="_blank" rel="noopener noreferrer"><Icon :icon="['fab', 'gitlab']"/> <u>@cklaassen</u> <Icon :icon="['fab', 'gitlab']"/></a></p>
    </div>
    <div class="flex justify-center">
      <p class="text-default hover:text-link"><a href="https://github.com/cklaassen" target="_blank" rel="noopener noreferrer"><Icon :icon="['fab', 'github']"/> <u>@cklaassen</u> <Icon :icon="['fab', 'github']"/></a></p>
    </div>
    <div class="content-center text-lg cursor-default text-default font-text my-10 mx-48">
      <span>Hello!  I am Connor Klaassen, a computer science student at Purdue University. I am currently working on gaining hands-on experience as a developer.  Along with my studies,
         I am building Keryx, a company that is designing a workspace to facilitate complex, relationship based communications.
        <br>
        <br>
        Ever since I was first introduced to programming in 5<sup>th</sup> grade on Khan Academy’s scripting emulator, it has been close to impossible to drag me away from an IDE.  Whether it’s
         attempting to automate my homework, building the next Fortune 500  company, or anything in between, I am passionate about it all.  The lure of being able to turn an empty file
          into a functioning complex system has kept me hooked ever since I wrote my first line of code.
      </span>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue'

export default {
  name: 'AboutMe',
  setup: function () {
    const loadAboutMe = inject('loadAboutMe')
    return {
      loadAboutMe
    }
  },
  methods: {
    route: function () {
      console.log('BACK')
      this.loadAboutMe()
    }
  }
}
</script>

<style scoped>

</style>
